import { useMemo } from 'react';
import { getAxiosClient } from '../http.client';
export function useBillingClient() {
    return useMemo(() => {
        return new BillingClient();
    }, []);
}
export class BillingClient {
    apiClient;
    constructor() { }
    async client() {
        if (this.apiClient) {
            return this.apiClient;
        }
        this.apiClient = getAxiosClient("billing");
        return this.apiClient;
    }
    async getQuotaStatus() {
        try {
            const client = await this.client();
            const response = await client.get('/quota-status');
            return response.data;
        }
        catch (error) {
            console.error('Failed to get quota status:', error);
            throw error;
        }
    }
    async makeAdditionalPurchase(priceId, metadata, successUrl, cancelUrl) {
        try {
            const client = await this.client();
            const response = await client.post('/checkout-session', {
                priceId,
                metadata,
                successUrl,
                cancelUrl,
            });
            return response.data;
        }
        catch (error) {
            console.error('Failed to make additional purchase:', error);
            throw error;
        }
    }
    async getInvoices(startingAfter, endingBefore) {
        try {
            const client = await this.client();
            const params = {};
            if (startingAfter) {
                params.starting_after = startingAfter;
            }
            if (endingBefore) {
                params.ending_before = endingBefore;
            }
            const response = await client.get('/invoices', { params });
            return response.data;
        }
        catch (error) {
            console.error('Failed to get invoices:', error);
            throw error;
        }
    }
}
